import React from "react";
import DoneToggle from "globalComponents/DoneToggle";
import CalendarIconSmall from "icons/CalendarIconSmall";
import ChecklistIconButton from "../../itemLists/items/ChecklistIconButton";
import ContentEditable from "react-contenteditable";

export default function ItemNameInput(props) {
  const {
    itemName,
    setItemName,
    itemType,
    taskType,
    itemDone,
    setItemDone,
    setOpenChecklist,
    itemHasChecklist,
    itemId,
  } = props;
  function namePrefix() {
    if (itemType === "calendar_note") {
      return (
        <div className="flex-center-div small">
          <CalendarIconSmall />
        </div>
      );
    } else {
      return <DoneToggle itemDone={itemDone} setItemDone={setItemDone} />;
    }
  }
  function handleInputKeyPress(event) {
    if (event.key === "Enter") {
      event.target.blur();
    }
  }
  function doneClass() {
    return itemDone ? "complete" : "incomplete";
  }

  function handleNameChange(event) {
    setItemName(event.target.value);
  }
  return (
    <div
      className={
        "Item-name-input-container item-view-row " + itemType + " " + taskType
      }
    >
      {namePrefix()}
      <ContentEditable
        html={itemName}
        className={"item-name-input " + doneClass()}
        onChange={handleNameChange}
        onKeyPress={handleInputKeyPress}
      />
      {itemHasChecklist && (
        <div className="flex-center-div">
          <ChecklistIconButton
            itemId={itemId}
            setOpenChecklist={setOpenChecklist}
          />
        </div>
      )}
    </div>
  );
}
